var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_31750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4452 17.4889C11.167 17.3332 10.8279 17.3332 10.5497 17.4889L6.26623 19.8866C5.58369 20.2687 4.76698 19.6754 4.9194 18.9081L5.87594 14.0933C5.93806 13.7806 5.83325 13.458 5.59918 13.2416L1.99466 9.90856C1.42034 9.37749 1.73226 8.41737 2.50904 8.32524L7.38409 7.74706C7.70065 7.70952 7.97497 7.51021 8.10851 7.22075L10.1651 2.76267C10.4927 2.05242 11.5021 2.05242 11.8298 2.76267L13.8863 7.22075C14.0199 7.51021 14.2942 7.70952 14.6107 7.74706L19.4858 8.32524C20.2626 8.41737 20.5745 9.37749 20.0002 9.90856L16.3957 13.2416C16.1616 13.458 16.0568 13.7806 16.1189 14.0933L17.0754 18.9081C17.2279 19.6754 16.4112 20.2687 15.7286 19.8866L11.4452 17.4889Z",
    fill: "#F9C332"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_31750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8bcd426bb020dc07cf9338b55495a2ea.svg";
export { ForwardRef as ReactComponent };